import { useRequest } from 'ahooks';
import { useState } from 'react';
import {
  addContactService,
  addTicketOrderService,
  changeBundleMemberService,
  changeBundleOfferService,
  checkChangeBundleOfferEligibilityService,
  getAddressAvailabilityCheckService,
  getCreateDemandService,
  getPremiseCategoryService,
  getStateService,
  getTncService,
  modContactService,
  modifyOfferService,
  preficationMultiCheckService,
  queryCheckCreateFixDemandCaseService,
  queryInstallationTypeService,
  queryOfferAttributeService,
  queryOfferService,
  queryRushOrderService,
  querySendBookingInfoService,
  querySlotService,
  relocationService,
} from '../services';

export default function MemberMgrBundleModel() {
  const [currentStep, setCurrentStep] = useState('');
  const [flowData, setFlowData] = useState<any>({});
  const [tcCheckeDisabled, setTcCheckedDisabled] = useState<boolean>(false); // tc是否勾选
  const [nextBtnDisabled, setNextBtnDisabled] = useState<boolean>(false); // bundle next按钮的禁用状态
  const [openDemand, setOpenDemand] = useState(false); // 控制demand提示框
  const [openCreateDemand, setOpenCreateDemand] = useState(false); // 控制创建demand
  const [addManuallyCheckDisabled, setAddManuallyCheckDisabled] =
    useState(false); // 手动新增地址控制按钮是否禁用
  const [selectAddressData, setSelectAddressData] = useState<any>({}); // 存储选中后的地址

  const {
    loading: addressStateLoading,
    data: addressStateList,
    run: queryState,
  } = useRequest(getStateService, {
    manual: true,
  });

  const {
    loading: availabilityCheckLoading,
    runAsync: queryAddressAvailabilityCheck,
    data: addressAvailabilityCheckData = {},
    mutate: mutateAddressAvailabilityCheckData,
  } = useRequest(getAddressAvailabilityCheckService, {
    manual: true,
  });

  const {
    loading: checkChangeBundleOfferEligibilityLoading,
    runAsync: checkChangeBundleOfferEligibility,
  } = useRequest(checkChangeBundleOfferEligibilityService, {
    manual: true,
  });

  const { loading: preficationLoading, runAsync: preficationMultiCheck } =
    useRequest(preficationMultiCheckService, {
      manual: true,
    });

  const { loading: addTicketOrderLoading, runAsync: addTicketOrder } =
    useRequest(addTicketOrderService, {
      manual: true,
    });

  const { runAsync: addContact } = useRequest(addContactService, {
    manual: true,
  });

  const { runAsync: modContact } = useRequest(modContactService, {
    manual: true,
  });

  const { runAsync: changeBundleOffer, loading: bundleOfferLoading } =
    useRequest(changeBundleOfferService, {
      manual: true,
    });

  const { runAsync: relocation, loading: relocationLoading } = useRequest(
    relocationService,
    {
      manual: true,
    },
  );

  const { run: queryTncService, data: tncData } = useRequest(getTncService, {
    manual: true,
  });

  const { runAsync: createDemand, loading: createDemandLoading } = useRequest(
    getCreateDemandService,
    {
      manual: true,
    },
  );

  const { data: premiseCategoryList, run: getPremiseCategory } = useRequest(
    getPremiseCategoryService,  { manual: true }
  );

  const {
    runAsync: queryInstallationType,
    data: installationTypedata = {},
    loading: installationTypeLoading,
    mutate: mutateInstallationTypeData,
  } = useRequest(queryInstallationTypeService, {
    manual: true,
  });
  const { runAsync: queryOfferAttrs, data: offerAttrsData = [] } = useRequest(
    queryOfferService,
    {
      manual: true,
    },
  );

  const { runAsync: queryRushOrder, data: rushOrderData = {} } = useRequest(
    queryRushOrderService,
    {
      manual: true,
    },
  );

  const { runAsync: querySlot, data: querySlotData = {} } = useRequest(
    querySlotService,
    {
      manual: true,
    },
  );

  const { data: offerAttributeData = [], runAsync: queryOfferAttribute } =
    useRequest(queryOfferAttributeService, { manual: true });

  const { data: sendBookingInfoData = {}, runAsync: querySendBookingInfo } =
    useRequest(querySendBookingInfoService, { manual: true });

  const { runAsync: modifyOfferSubmit, loading: modifyOfferLoading } =
    useRequest(modifyOfferService, {
      manual: true,
    });

  const { runAsync: getCheckCreateFixDemandCase } = useRequest(
    queryCheckCreateFixDemandCaseService,
    {
      manual: true,
    },
  );

  const { runAsync: changeBundleMember, loading: bundleBunldeMemberLoading } =
    useRequest(changeBundleMemberService, {
      manual: true,
    });

  const updateFlowData = (newData: any) => {
    setFlowData({
      ...flowData,
      ...newData,
    });
  };

  const resetData = () => {
    setCurrentStep('');
    setFlowData({});
  };

  const handleDemand = (status: boolean, name: string) => {
    if (name === 'createDemand') {
      setOpenCreateDemand(true);
    }
    setOpenDemand(status);
  };

  return {
    currentStep, // 当前展示界面
    flowData,
    addressStateList,
    queryState,
    setCurrentStep,
    updateFlowData, // 更新界面选择数据
    resetData, // 清空界面选择数据
    addContact,
    modContact,
    addTicketOrder,
    queryAddressAvailabilityCheck,
    preficationMultiCheck,
    changeBundleOffer,
    relocation,
    addressStateLoading,
    changeBundleOfferLoading:
      bundleOfferLoading ||
      availabilityCheckLoading ||
      addTicketOrderLoading ||
      preficationLoading ||
      relocationLoading ||
      checkChangeBundleOfferEligibilityLoading ||
      bundleBunldeMemberLoading,
    queryTncService,
    tncData,
    tcCheckeDisabled,
    setTcCheckedDisabled,
    nextBtnDisabled,
    setNextBtnDisabled,
    createDemandLoading,
    createDemand,
    openDemand,
    setOpenDemand,
    openCreateDemand,
    setOpenCreateDemand,
    handleDemand,
    queryInstallationType,
    installationTypedata,
    queryRushOrder,
    rushOrderData,
    querySlot,
    querySlotData,
    addressAvailabilityCheckData,
    queryOfferAttribute,
    offerAttributeData,
    sendBookingInfoData,
    querySendBookingInfo,
    modifyOfferSubmit,
    modifyOfferLoading,
    queryOfferAttrs,
    installationTypeLoading,
    offerAttrsData: offerAttrsData?.productOffering || [],
    addManuallyCheckDisabled,
    setAddManuallyCheckDisabled,
    getCheckCreateFixDemandCase,
    selectAddressData,
    setSelectAddressData,
    mutateInstallationTypeData,
    mutateAddressAvailabilityCheckData,
    checkChangeBundleOfferEligibility,
    changeBundleMember,
    getPremiseCategory,
    premiseCategoryList,
  };
}
